import { render, staticRenderFns } from "./EliminationBracket.vue?vue&type=template&id=19122324&scoped=true"
import script from "./EliminationBracket.vue?vue&type=script&lang=js"
export * from "./EliminationBracket.vue?vue&type=script&lang=js"
import style0 from "./EliminationBracket.vue?vue&type=style&index=0&id=19122324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19122324",
  null
  
)

export default component.exports